import { tv } from "@ui/lib/tv";
import { Link } from "@ui/primitives/Link";
import type { Costs } from "../../apply-household";

const costAttribution = tv({
  slots: {
    root: "text-neutral-400 text-xs",
    link: "underline decoration-neutral-300 underline-offset-2 hover:decoration-neutral-500",
  },
});

export interface CostAttributionProps {
  attributions: Costs["attributions"];
}

/**
 * The credit line. Every source's own words, joined: an attribution obligation
 * is a term we agreed to, so the text is the registry's and not ours to
 * paraphrase.
 */
export function CostAttribution({ attributions }: CostAttributionProps) {
  const styles = costAttribution();
  if (attributions.length === 0) return null;

  return (
    <p className={styles.root()}>
      {attributions.map((attribution, index) => (
        <span key={attribution.source}>
          {index > 0 && " · "}
          {attribution.url ? (
            <Link className={styles.link()} href={attribution.url} rel="noreferrer noopener" target="_blank">
              {attribution.text}
            </Link>
          ) : (
            attribution.text
          )}
        </span>
      ))}
    </p>
  );
}
